import { InjectionToken } from '@angular/core';
import { jsPDF } from 'jspdf';

export const JSPDF_TOKEN = new InjectionToken<typeof jsPDF>('jsPDF', {
    providedIn: 'root',
    factory: () => jsPDF,
});
